import { Helmet } from "react-helmet";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogImage?: string;
  structuredData?: object;
}

export const SEO = ({ 
  title, 
  description, 
  keywords = "umbanda, terreiro, pai joaquim de aruanda, orlando, florida, espiritualidade, religião afro-brasileira, orixás",
  canonicalUrl,
  ogImage = "https://storage.googleapis.com/gpt-engineer-file-uploads/f2TGt83oDtNkqsJJHv7aMMN8Ysi1/social-images/social-1764568801929-tupja-fundo-branco.png",
  structuredData
}: SEOProps) => {
  const siteUrl = window.location.origin;
  const fullCanonicalUrl = canonicalUrl || window.location.href;
  const fullTitle = `${title} | TUPJA - Terreiro Pai Joaquim de Aruanda`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="TUPJA - Terreiro Pai Joaquim de Aruanda" />
      <link rel="canonical" href={fullCanonicalUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={fullCanonicalUrl} />
      <meta property="og:site_name" content="TUPJA - Terreiro Pai Joaquim de Aruanda" />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="Portuguese" />
      <meta name="geo.region" content="US-FL" />
      <meta name="geo.placename" content="Orlando" />
      <meta name="geo.position" content="28.527787;-81.367402" />
      <meta name="ICBM" content="28.527787, -81.367402" />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}

      {/* Organization Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "TUPJA - Terreiro Pai Joaquim de Aruanda",
          "alternateName": "Terreiro Pai Joaquim de Aruanda",
          "url": siteUrl,
          "logo": `${siteUrl}/logo-tupja.png`,
          "description": "Terreiro de Umbanda Tradicional em Orlando, Florida, dedicado à prática espiritual e acolhimento de todas as pessoas",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "316 Goodland St",
            "addressLocality": "Orlando",
            "addressRegion": "FL",
            "postalCode": "32805",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "28.527787",
            "longitude": "-81.367402"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "Customer Service",
            "availableLanguage": ["Portuguese", "English"]
          }
        })}
      </script>
    </Helmet>
  );
};